import { Grid, Typography } from "@mui/material";
import eSignFailure from "../../assets/svg/nomine_3.png";

const ESignFailure = () => {

    return (
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
        
            <Grid item xs={12} textAlign="center">
                <img src={eSignFailure} alt="E-sign success illustration" style={{ maxWidth: "10%", height: "auto", marginTop: "16px" }} />
            </Grid>

            <Grid item xs={12}>
                <Typography sx={{ textAlign: "center", color: "#131E2E", fontWeight: "600", fontSize: { xs: "14px", sm: "16px" } }}>
                    Please contact our support team for further assistance.
                </Typography>
            </Grid>

            <Grid item xs={12}>
  <Typography
    sx={{
      textAlign: "center",
      color: "#007FFE",
      fontWeight: "400",
      fontSize: { xs: "16px", },
      mb: 2,
      mt: 1
    }}
  >
    <a
      href="mailto:support@tradeboss.co"
      style={{
        color: "inherit",
        textDecoration: "none"
      }}
    >
      support@tradeboss.co
    </a>
  </Typography>
</Grid>


        </Grid>
    );
};

export default ESignFailure;
